import { ArrowUp, Linkedin, Twitter, Instagram } from "lucide-react";
import { motion } from "framer-motion";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const currentYear = new Date().getFullYear();

  const navLinks = [
    { href: "#about", label: "About" },
    { href: "#skills", label: "Expertise" },
    { href: "#projects", label: "Selected Works" },
    { href: "#experience", label: "Experience" },
  ];

  return (
    <footer className="bg-slate-950 text-slate-200 pt-32 pb-12 px-4 md:px-8 overflow-hidden">      <div className="max-w-7xl mx-auto">
        
        {/* --- CTA removed per request --- */}

        {/* --- 2. GRID CONTENT --- */}
        <div className="grid md:grid-cols-12 gap-12 mb-24">
          
          {/* Brand Column */}
          <div className="md:col-span-5">
            <Reveal>
                <h3 className="text-2xl font-bold text-white mb-6">Anant Mishra</h3>
                <p className="text-slate-500 text-lg leading-relaxed max-w-sm">
                   A Product Manager focused on clarity, strategy, and execution. Based in the United States, working globally.
                </p>
            </Reveal>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-widest text-slate-600 mb-8">Sitemap</h4>
            <ul className="space-y-4">
              {navLinks.map((link) => (
                <li key={link.href} className="overflow-hidden">
                  <Reveal delay={0.1}>
                      <a href={link.href} className="text-lg text-slate-400 hover:text-white transition-colors block py-1">
                        {link.label}
                      </a>
                  </Reveal>
                </li>
              ))}
            </ul>
          </div>

          {/* Socials */}
          <div className="md:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-widest text-slate-600 mb-8">Socials</h4>
            <div className="flex flex-wrap gap-4">
                <SocialLink href="https://linkedin.com" icon={Linkedin} label="LinkedIn" />
                <SocialLink href="https://twitter.com" icon={Twitter} label="Twitter" />
                <SocialLink href="https://instagram.com" icon={Instagram} label="Instagram" />
            </div>
          </div>

        </div>

        {/* --- 3. BOTTOM BAR --- */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8 border-t border-slate-900 text-sm text-slate-600">
          <p>© {currentYear} Anant Mishra. All Rights Reserved.</p>
          
          <button 
            onClick={scrollToTop} 
            className="group flex items-center gap-2 text-white font-bold uppercase tracking-widest hover:text-blue-500 transition-colors"
          >
            Back to Top
            <ArrowUp className="w-4 h-4 group-hover:-translate-y-1 transition-transform" />
          </button>
        </div>

      </div>
    </footer>
  );
};

// --- HELPER COMPONENTS ---

const SocialLink = ({ href, icon: Icon, label }) => (
    <a 
        href={href} 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex items-center gap-3 px-6 py-4 border border-slate-800 rounded-full hover:bg-slate-800 hover:border-slate-700 transition-all group"
    >
        <Icon className="w-5 h-5 text-slate-400 group-hover:text-white transition-colors" />
        <span className="text-slate-400 font-medium group-hover:text-white transition-colors">{label}</span>
    </a>
);

// THE "EXPENSIVE" REVEAL ANIMATION
// Wraps content in a hidden box and slides it up
const Reveal = ({ children, delay = 0 }) => (
    <div className="overflow-hidden">
        <motion.div
            initial={{ y: "100%" }}
            whileInView={{ y: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay }}
        >
            {children}
        </motion.div>
    </div>
);

export default Footer;